import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { ChartEnums } from "models/enums";
//#endregion
//#region components
import { ChartContainer } from "components/common";
//#endregion
import { useArticleService, useInvoiceService } from "serviceHooks";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { useNavigate } from "react-router-dom";
import { UrlHelper } from "utils/helpers";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;

const ArticlesSalesSummaryPieChart: React.FC = () => {
  const articleService = useArticleService();
  const invoiceService = useInvoiceService();
  const navigate = useNavigate();
  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Pie}
      chartAPIKey={GraphConstants.ChartKeys.ArticlesSalesSummary}
      filterToAPIHandler={articleService.reportToAPIFilter}
      showTotal
      doughnutChartLegendType={ChartEnums.LegendType.WITH_VALUES}
      doughnutChartColorPalette={ChartEnums.DoughnutChartColorPalette.DEFAULT}
      usePageFilter
      useClickableChart
      onDataPointClick={(index, label) => {
        const clickedLabel = typeof label === "string" ? label : undefined;
        if (!clickedLabel) return;
        invoiceService.searchArticles(clickedLabel).then((results: WintSuperkollAPIModel.ArticleSearchResponse[]) => {
          const exact = results.find(
            (r: WintSuperkollAPIModel.ArticleSearchResponse) =>
              (r.name ?? "").toLowerCase() === clickedLabel.toLowerCase()
          );
          const target = exact ?? results[0];
          if (target?.id) navigate(UrlHelper.formatPath(`/Article/${target.id}`));
        });
      }}
    />
  );
};

export default ArticlesSalesSummaryPieChart;
